export const TRANSACTION = "transaction";

export interface InitialState {
  transactions: Array<TransactionType>;
  isFetching: boolean;
  income: number;
  expense: number;
  transfer: number;
}

export enum TransactionTypeEnum {
  INCOME = "Income",
  EXPENSE = "Expense",
  TRANSFER = "Transfer",
}

export type TransactionType = {
  _id: string;
  amount: number;
  date: string;
  category: string;
  description: string;
  createdAt: string;
  type: TransactionTypeEnum;
};

export interface Reducers {
  [key: string]: (state: InitialState, action: any) => void;
}
